import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRange5 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 160 160",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M157.805 61.2194C150.346 55.072 140.791 53.1517 131.507 50.3582C133.563 44.1388 135.585 37.9329 136.75 31.7553C139.363 12.0334 116.337 21.5013 94.3802 27.6905C87.8062 19.7382 81.893 10.834 74.8138 3.76827C62.5725 -7.18668 56.9303 7.51527 51.2546 25.1512C44.2474 23.082 37.1415 21.2855 30.0941 19.3451C29.8482 19.2765 29.5872 19.2196 29.3347 19.1795C5.52281 15.496 24.6492 50.4268 27.6769 65.6105C19.6694 71.6575 12.1604 78.4038 4.49406 84.9142C4.29834 85.0798 4.1043 85.2621 3.93034 85.4495C-7.37088 97.5386 7.78606 103.147 23.0066 107.436C14.9572 133.09 7.00154 149.264 62.1962 129.04C62.5474 128.898 62.8987 128.762 63.2483 128.634C84.9458 151.256 94.5826 182.057 109.179 134.756C116.033 136.885 122.928 138.523 129.947 138.269C133.078 138.155 135.734 135.811 136.02 132.69C137.134 120.481 130.734 109.317 128.132 97.3261C138.578 88.2045 151.662 81.035 159.001 69.3792C160.67 66.7279 160.23 63.2134 157.812 61.2194H157.805Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgRange5);
export default ForwardRef;
